import * as ActionTypes from 'state/types'
import * as Selectors from 'state/selectors'
import Routes from 'shared/utils/api/routes'

import { fetchActivities, getActivitiesDates } from 'state/actions/activities'
// TODO Refactor

export const selectInteraction = (interaction) => ({

  type: 'CONSISTENT_MULTIPLE_ACTIONS',
  payload: {
    actions: [
      {
        type: ActionTypes.SELECT_INTERACTION,
        payload: interaction
      },
      {
        type: ActionTypes.NOTICE_INTERACTION
      },
      fetchActivities(),
      getActivitiesDates()
    ]
  }
})

export const fetchInteractions = () => ({

  type: ActionTypes.INTERACTIONS_LIST_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.INTERACTIONS_LIST_ROUTE,
    method: 'get',
    unique: true
  },
  meta: {
    finalActionType: ActionTypes.INTERACTIONS_LIST_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getInteractionsNextPage,
        deepLevel:['params'],
        key: 'page'
      },
      {
        selector: Selectors.getSelectedInbox,
        deepLevel: ['params'],
        key: 'inbox'
      },
      {
        selector: Selectors.getSelectedFilter,
        deepLevel: ['params'],
        key: 'filter'
      }
    ]
  }
})
export const deleteInteraction = () => ({

  type: 'CONSISTENT_MULTIPLE_ACTIONS',
  payload: {
    actions: [
      {
        type: ActionTypes.DELETE_PAUSES_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.PAUSE_REMOVE_ROUTE,
          method: 'delete'
        },
        selectorsToPayload: [
          {
            selector: Selectors.getActiveAgentId,
            deepLevel:['data'],
            key: 'agentId'
          },
          {
            selector: Selectors.getSelectedInteractionThreadIds,
            deepLevel:['data'],
            key: 'threads'
          }
        ]
      },
      {
        type: ActionTypes.DELETE_INTERACTION_REQUEST,
        payload: {
          url: Routes.INTERACTIONS_REMOVE_ROUTE,
          method: 'delete'
        },
        selectorsToPayload: [
          {
            selector: Selectors.getActiveAgentId,
            deepLevel:['data'],
            key: 'agentId'
          },
          {
            selector: Selectors.getSelectedInteractionId,
            deepLevel:['data'],
            key: 'interactionId'
          }
        ]
      }
    ]
  }
})
export const archiveInteraction = () => ({

  type: 'CONSISTENT_MULTIPLE_ACTIONS',
  payload: {
    actions: [
      {
        type: ActionTypes.DELETE_PAUSES_REQUEST,
        provideResponse: false,
        provideParentPayload: false,
        payload: {
          url: Routes.PAUSE_REMOVE_ROUTE,
          method: 'delete'
        },
        selectorsToPayload: [
          {
            selector: Selectors.getActiveAgentId,
            deepLevel:['data'],
            key: 'agentId'
          },
          {
            selector: Selectors.getSelectedInteractionThreadIds,
            deepLevel:['data'],
            key: 'threads'
          }
        ]
      },
      {
        type: ActionTypes.ARCHIVE_INTERACTION_REQUEST,
        payload: {
          url: Routes.INTERACTIONS_ARCHIVE_ROUTE,
          method: 'put'
        },
        selectorsToPayload: [
          {
            selector: Selectors.getActiveAgentId,
            deepLevel:['data'],
            key: 'agentId'
          },
          {
            selector: Selectors.getSelectedInteractionId,
            deepLevel:['data'],
            key: 'interactionId'
          }
        ]
      }
    ]
  }
})

export const unArchiveInteraction = () => ({

  type: ActionTypes.UNARCHIVE_INTERACTION_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.INTERACTIONS_UNARCHIVE_ROUTE,
    method: 'put'
  },
  meta: {
    finalActionType: ActionTypes.UNARCHIVE_INTERACTION_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActiveAgentId,
        deepLevel:['data'],
        key: 'agentId'
      },
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['data'],
        key: 'interactionId'
      }
    ]
  }
})
export const assignInteraction = () => ({

  type: ActionTypes.ASSIGN_INTERACTION_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.INTERACTIONS_ASSIGN_ROUTE,
    method: 'put'
  },
  meta: {
    finalActionType: ActionTypes.ASSIGN_INTERACTION_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActiveAgentId,
        deepLevel:['data'],
        key: 'agentId'
      },
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['data'],
        key: 'interactionId'
      }
    ]
  }
})
export const unAssignInteraction = () => ({

  type: ActionTypes.UNASSIGN_INTERACTION_PREPARE,
  provideResponse: false,
  provideParentPayload: false,
  payload: {
    url: Routes.INTERACTIONS_UNASSIGN_ROUTE,
    method: 'put'
  },
  meta: {
    finalActionType: ActionTypes.UNASSIGN_INTERACTION_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getActiveAgentId,
        deepLevel:['data'],
        key: 'agentId'
      },
      {
        selector: Selectors.getSelectedInteractionId,
        deepLevel:['data'],
        key: 'interactionId'
      }
    ]
  }
})

export const updatedInteractionReceived = (interaction, profile) => ({
  type: ActionTypes.RECEIVE_UPDATED_INTERACTION,
  interaction,
  profile
})

export const noticedInteractionReceived = interaction => ({
  type: ActionTypes.RECEIVE_NOTICED_INTERACTION,
  payload: {
    interaction
  }
})

export const newInteractionReceived = (interaction, profile) => ({
  type: ActionTypes.RECEIVE_NEW_INTERACTION,
  interaction,
  profile
})

export const receiveDeletedInteraction = interaction => ({
  type: ActionTypes.RECEIVE_DELETED_INTERACTION,
  interaction
})

export const triggerEvent = (eventName) => ({

  type: 'CONSISTENT_MULTIPLE_ACTIONS',
  payload: {
    actions: [
      {
        type: ActionTypes.DELETE_PAUSES_REQUEST,
        payload: {
          url: Routes.PAUSE_REMOVE_ROUTE,
          method: 'delete'
        },
        selectorsToPayload: [
          {
            selector: Selectors.getActiveOrganisationId,
            deepLevel:['data'],
            key: 'organisationId'
          },
          {
            selector: Selectors.getActiveAgentId,
            deepLevel:['data'],
            key: 'agentId'
          },
          {
            selector: Selectors.getSelectedInteractionThreadIds,
            deepLevel:['data'],
            key: 'threads'
          }
        ],
        meta: {
          successActions: [
            {
              type: ActionTypes.TRIGGER_EVENT_REQUEST,
              provideResponse: false,
              provideParentPayload: false,
              payload: {
                url: Routes.TRIGGER_EVENT_ROUTE,
                method: 'post',
                data: {
                  eventName
                }
              },
              selectorsToPayload: [
                {
                  selector: Selectors.getActiveOrganisationId,
                  deepLevel:['data'],
                  key: 'organisationId'
                },
                {
                  selector: Selectors.getActiveAgentId,
                  deepLevel:['data'],
                  key: 'agentId'
                },
                {
                  selector: Selectors.getUserProfile,
                  deepLevel:['data'],
                  key: 'profile'
                },
                {
                  selector: Selectors.prepareActorForTriggerEvent,
                  deepLevel:['data'],
                  key: 'actor'
                },
                {
                  selector: Selectors.prepareThreadsForTriggerEvent,
                  deepLevel:['data'],
                  key: 'threads'
                }
              ]
            }
          ]
        }
      }
    ]
  }
})
export const interactionInfoRequest = interactionId => ({

  type: ActionTypes.INTERACTION_INFO_PREPARE,
  payload: {
    url: Routes.INTERACTIONS_INFO_ROUTE,
    method: 'get',
    unique: true,
    params: {
      interactionId
    }
  },
  meta: {
    finalActionType: ActionTypes.INTERACTION_INFO_REQUEST,
    selectorsToPayload: [
      {
        selector: Selectors.getSelectedInbox,
        deepLevel: ['params'],
        key: 'inbox'
      },
      {
        selector: Selectors.getSelectedFilter,
        deepLevel: ['params'],
        key: 'filter'
      }
    ],
    meta: {
      successActions: [
        fetchActivities(),
        getActivitiesDates()
      ],
      errorActions: [
        {
          type: ActionTypes.REDIRECT_TO_ALL_MESSAGES
        }
      ]
    }
  }
})
